import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PageSizeService } from '../../../services/page-size.service';
import { ButtonIconComponent } from '../../../shared/components/button-icon/button-icon.component';
import {TranslateSafePipe} from '../../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-settings-navigation',
  standalone: true,
  imports: [
    ButtonIconComponent,
    RouterLink,
    RouterLinkActive,
    TranslateSafePipe,
  ],
  templateUrl: './settings-navigation.html',
  styleUrls: [
    './settings-navigation.css',
    '../../../shared/styles/side-navigation-base.css',
  ],
})
export class SettingsNavigationComponent {
  public openMenu: boolean = false;

  constructor(
    private readonly _pageSizeService: PageSizeService,
  ) {

  }

  public get isMobileView(): boolean {
    return this._pageSizeService.isMobileSize || this._pageSizeService.isTabletSize;
  }

  public toggleMobileView() {
    this.openMenu = !this.openMenu;
  }

  public closeMobileView() {
    this.openMenu = false;
  }
}
